import { useState } from 'react';

export const useConfirm = () => {
  const [modal, setModal] = useState(null);

  const confirm = (options) => {
    return new Promise((resolve) => {
      setModal({
        ...options,
        onConfirm: () => {
          setModal(null);
          resolve(true);
        },
        onCancel: () => {
          setModal(null);
          resolve(false);
        }
      });
    });
  };

  const alert = (message, title = 'Success', type = 'success') => {
    return new Promise((resolve) => {
      setModal({
        type,
        title,
        message,
        onConfirm: () => {
          setModal(null);
          resolve(true);
        },
        onCancel: () => {
          setModal(null);
          resolve(true);
        }
      });
    });
  };

  return { confirm, alert, modal };
};
